export const getSegmentId = (segment) => segment?.segment_id || segment?.segmentId || segment?.id || "";

export const isSeparateServiceSegment = (segment) =>
  Number(segment?.segment_group_id) === 2 &&
  segment?.segment_sub_group !== null && segment?.segment_sub_group !== undefined &&
  Number(segment.segment_sub_group) === 0;

export const isShoppingSegment = (segment) => !isSeparateServiceSegment(segment);

export const requiresSegmentAddress = (segment) =>
  Number(segment?.segment_sub_group) === 2 &&
  [true, 1, "1", "true"].includes(segment?.enable_address_screen);

export const getSegmentPath = (segment) => isSeparateServiceSegment(segment)
  ? "/home"
  : `/stores/${encodeURIComponent(getSegmentId(segment))}`;

export const getSegmentItems = (response) => {
  const candidates = [
    response?.data?.cell_contents, response?.cell_contents,
    response?.data?.response_data?.[0]?.cell_contents, response?.response_data?.[0]?.cell_contents,
    response?.data?.response_data, response?.response_data, response?.data, response,
  ];
  return candidates.find(Array.isArray) || [];
};
